import { EntityList } from "../../components/entity-management";
import { api } from "../../services/api";

const zoneConfig = {
  queryKey: "search-zones",
  api: {
    getList: () => api.getZones(),
    create: (data: { name: string }) => api.createZone(data),
    update: (id: string, data: { id?: string; name: string }) => api.updateZone(id, data),
    delete: (id: string) => api.deleteZone(id),
  },
  labels: { entityName: "Zone" },
};

export function ZoneList() {
  return <EntityList config={zoneConfig} />;
}
